import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { fetchDropDownData } from "../fetchDropDownData";
import { ItemType } from "../../models/ItemTypes";

export const BomUtils = () => {
  const [itemOptions, setItemOptions] = useState<any[]>([]);

  const fetchItems = useCallback(
    debounce((inputValue: string) => {
      fetchDropDownData({
        endpoint: "/items",
        searchKey: "internalPartNo",
        searchTerm: inputValue,
        labelKey: "internalPartNo",
        valueKey: "_id",
      }).then((data: any) => {
        console.log(data);

        const formattedResponse = data.map((item: any) => ({
          label: item.internalPartNo,
          value: item._id,
          uom: item.uom.name
        }))
        console.log("formatted response: ", formattedResponse);

        setItemOptions(formattedResponse)
      });
    }, 500),
    []
  );


  return {
    itemOptions,
    fetchItems
  };
};
